import React from "react";
import { MapPin } from "lucide-react";
import { http } from "@/lib/api";

export default function Lieux() {
  const [locations, setLocations] = React.useState([]);
  const [courses, setCourses] = React.useState([]);
  React.useEffect(() => {
    http.get("/locations").then(r => setLocations(r.data)).catch(() => setLocations([]));
    http.get("/courses").then(r => setCourses(r.data)).catch(() => setCourses([]));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="he-overline text-neutral-500">Val-de-Marne</p>
      <h1 className="font-heading text-5xl sm:text-6xl font-black tracking-tighter mt-3">Où danser avec nous ?</h1>
      <p className="mt-4 text-neutral-600 font-body max-w-2xl">
        Nos cours ont lieu principalement dans trois villes : Fresnes, L’Haÿ-les-Roses et Chevilly-Larue.
      </p>

      <div className="mt-14 space-y-6">
        {locations.map((l) => {
          const related = courses.filter(c => c.city === l.city);
          const mapQuery = encodeURIComponent(`${l.name}, ${l.city}`);
          return (
            <article key={l.id} className="border border-black/10 rounded-2xl overflow-hidden grid grid-cols-1 md:grid-cols-2">
              <div className="p-6 sm:p-8">
                <div className="he-overline text-neutral-500">{l.city}</div>
                <h3 className="font-heading text-3xl font-bold tracking-tight mt-2">{l.name}</h3>
                <p className="mt-3 text-sm text-neutral-600 font-body flex items-start gap-2"><MapPin className="w-4 h-4 text-[var(--he-red)] mt-0.5" /> {l.address || "Adresse à compléter"}</p>
                {l.access ? <p className="mt-2 text-xs text-neutral-500">Accès : {l.access}</p> : null}
                {related.length > 0 && (
                  <div className="mt-6">
                    <div className="he-overline text-neutral-500 mb-2">Cours ici</div>
                    <ul className="space-y-1 text-sm font-body text-neutral-700">
                      {related.map(c => (
                        <li key={c.id}>· {c.name} — {c.day} {c.start}-{c.end}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="aspect-[16/10] md:aspect-auto bg-neutral-100 min-h-[240px]">
                <iframe
                  title={`Carte ${l.name}`}
                  src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                  className="w-full h-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
